import gettersMethods from './getters';
import mutationsMethods from './mutations';
import actionsMethods from './actions';

export default {
   namespaced : true,

   state() {
      return {
         language: getCookie(LANG_COOKIE_NAME) || DEFAULT_LANG, 
      }
   },

   getters: gettersMethods,
   mutations: mutationsMethods,
   actions: actionsMethods,
};
